export class PoLineItemBase {
    description = ''
    glCo = 1
    glAccount = ''
    glAccountDescription = ''
    reqDate: Date | null = new Date()
    um = ''
    units = 0
    unitCost = 0
    taxType = ''
    taxCode = ''
    taxRate = 0
    supplier = ''

    get total(): number {
        return this.units * this.unitCost
    }
}

export class JobMaterialItem extends PoLineItemBase {
    jcCo = 1
    job = ''
    phase = ''
    costType: number | null = null
    material = ''
    vendorMaterial = ''
    receiving = false
    ticket = ''
}

/** Line item for Credit Card PO wizard (POC — fields subject to customer feedback; not yet persisted server-side). */
export class CreditCardItem extends JobMaterialItem {
    cardholderName = ''
    /** Last 4 digits only for POC UI; production may use tokenization / no PAN entry. */
    cardLastFour = ''
    /** Merchant or payee when different from the approved vendor / ad-hoc purchase. */
    merchantOrPayee = ''
    transactionDate: Date | null = new Date()
    businessPurpose = ''
    /** Broad bucket for stakeholder discussion (Travel, Fuel, Supplies, Other, …). */
    expenseCategory = ''
    isPersonalExpense = false
}

export class EquipmentWoItem extends PoLineItemBase {
    emCo = 1
    workOrder = ''
    workOrderDescription = ''
    woItem: number | null = null
    costCode = ''
    costType: number | null = null
    equipment = ''
    component = ''
}

export class EquipmentItem extends PoLineItemBase {
    emCo = 1
    equipment = ''
    equipmentDescription = ''
    compType = ''
    component = ''
    costCode = ''
    costType: number | null = null
    material = ''
    vendorMaterial = ''
    receiving = false
}

export class ExpenseItem extends PoLineItemBase {
    material = ''
    vendorMaterial = ''
    receiving = false
}
